import { useEffect, useRef } from 'react';

//use in no video scene
const useVideoControl = () => {
    const player = useRef<MultiPlayer.VideoPlayer>();
    const onVideoEvent = () => {
        if (player.current) {
            console.log(`app::video::channel::video::destroy`);
            player.current.Destroy();
            player.current = undefined;
        }
    };
    useEffect(() => {
        try {
            player.current = MultiPlayer.VideoPlayer.GetInstance();
            player.current.on(MultiPlayer.Event.VideoEvent.Play, onVideoEvent);
            player.current.on(MultiPlayer.Event.VideoEvent.Open, onVideoEvent);
        } catch (e) {
            console.log('MultiPlayer not inited');
        }
        return () => {
            if (player.current) {
                player.current.off(
                    MultiPlayer.Event.VideoEvent.Play,
                    onVideoEvent
                );
                player.current.off(
                    MultiPlayer.Event.VideoEvent.Open,
                    onVideoEvent
                );
                player.current = undefined;
            }
        };
    }, []);
};
export default useVideoControl;
